import React, {useEffect, useState} from 'react'
import RootAdmin from '../../../../components/layouts/RootAdmin'
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownTrigger,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableColumn,
    TableHeader,
    TableRow,
    Select, SelectItem
} from '@nextui-org/react'
import HeaderPage from '../../../../components/elements/HeaderPage'
import { FunnelIcon } from '@heroicons/react/24/outline'
import { BarChart } from '@mui/x-charts/BarChart';
import useSWR from "swr";
import {useForm} from "react-hook-form";
import ControlledInput from "../../../../components/elements/ControlledInput";
import {format} from 'date-fns'
import { month } from '../../../../enums/month'
import { monthNames, translateMonth } from '../../../../services/helpers'
import { getFetcher, HIGHCHART_URL } from "../../../../services/api";
import FilterInTab from "../../../../components/elements/FilterInTab";
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official';
import highchartsExporting from 'highcharts/modules/exporting';
import { isiSel, kelasKolom, kelasKolomDariData } from "../../../../services/angkaTabel";

// Initialize Highcharts exporting modules
highchartsExporting(Highcharts);

export default function ImportGrafik() {
    const currentDate = new Date();
    const defaultMonth = currentDate.getMonth() + 1;
    const defaultYear = currentDate.getFullYear();
  
    const [filters, setFilters] = useState({
        realisasiB3: { month: defaultMonth, year: defaultYear },
        realisasiB3Tahun: { year: defaultYear },
      perusahaanBulanTahun: { month: defaultMonth, year: defaultYear },
      realisasiPerusahaanTahun: { year: defaultYear },
      realisasiB3TahunProvinsi: { year: defaultYear, provinceId: 1 },
      realisasiPerusahaanProvinsiTahun: {year: defaultYear, provinceId: 1  },
      provinsiDistribusiTahun: { year: defaultYear },
      negaraAsal: {year: defaultYear},
      pelabuhanBongkar: {year: defaultYear}
    });
    const formattedDate = format(currentDate, 'dd-MM-yyyy');
    const [startDate, setStartDate] = useState(formattedDate);
    const [endDate, setEndDate] = useState(formattedDate);
    const [selectedProvince, setSelectedProvince] = useState('');

    const updateFilter = (key, newFilter) => {
        setFilters((prev) => ({
          ...prev,
          [key]: { ...prev[key], ...newFilter },
        }));
      };

    const { data: provinces } = useSWR('/api/location/provinces', getFetcher);

    const { data: perbandingan, mutate: mutatePerbandingan } = useSWR(
        `/api/dashboard/pelaporan/import/grafik/perbandingan?startDate=${startDate}&endDate=${endDate}`,
        getFetcher
    );

    const { data: b3, mutate: mutateB3 } = useSWR(
        `/api/dashboard/pelaporan/import/grafik/bahanb3-terbanyak?startDate=${startDate}&endDate=${endDate}`,
        getFetcher
    );

    const { data: perusahaan, mutate: mutatePerusahaan } = useSWR(
        `/api/dashboard/pelaporan/import/grafik/perusahaan-terbanyak?startDate=${startDate}&endDate=${endDate}`,
        getFetcher
    );

     const { data: negaraAsal, mutate: mutateNegaraAsal } = useSWR(() => {
        // Validasi filter
        const startYear = filters.negaraAsal.year || new Date().getFullYear(); // Default ke tahun ini jika tidak ada
    
        // Format tanggal dengan zero padding
        const formatDate = (day, month, year) => `${day.toString().padStart(2, "0")}-${month.toString().padStart(2, "0")}-${year}`;
        
        // Tanggal awal dan akhir
        const startDate = formatDate(1, 1, startYear); // Hari pertama bulan
        const endDate = formatDate(31, 12, startYear); // Hari terakhir bulan
    
        // Return URL dengan query string
        return `/api/dashboard/pelaporan/import/grafik/asal-negara-terbanyak?startDate=${startDate}&endDate=${endDate}`
    },
        getFetcher
    );

    const { data: pelabuhanBongkar, mutate: mutatePelabuhanBongkar } = useSWR(() => {
        // Validasi filter
        const startYear = filters.pelabuhanBongkar.year || new Date().getFullYear(); // Default ke tahun ini jika tidak ada
    
        // Format tanggal dengan zero padding
        const formatDate = (day, month, year) => `${day.toString().padStart(2, "0")}-${month.toString().padStart(2, "0")}-${year}`;
        
        // Tanggal awal dan akhir
        const startDate = formatDate(1, 1, startYear); // Hari pertama bulan
        const endDate = formatDate(31, 12, startYear); // Hari terakhir bulan
    
        // Return URL dengan query string
        return `/api/dashboard/pelaporan/import/grafik/pelabuhan-bongkar-terbanyak?startDate=${startDate}&endDate=${endDate}`
    },
        getFetcher
    );

    const { data: realisasiB3, mutate: mutateRealisasiB3 } = useSWR(() => {
        // Validasi filter
        const startMonth = filters.realisasiB3.startMonth || "01"; // Default ke Januari jika tidak ada
        const startYear = filters.realisasiB3.startYear || new Date().getFullYear(); // Default ke tahun ini jika tidak ada
        const endMonth = filters.realisasiB3.endMonth || startMonth; // Default ke bulan yang sama jika tidak ada
        const endYear = filters.realisasiB3.endYear || startYear; // Default ke tahun yang sama jika tidak ada
    
        // Format tanggal dengan zero padding
        const formatDate = (day, month, year) => `${day.toString().padStart(2, "0")}-${month.toString().padStart(2, "0")}-${year}`;
    
        // Tanggal awal dan akhir
        const startDate = formatDate(1, startMonth, startYear); // Hari pertama bulan
        const endDate = formatDate(new Date(endYear, endMonth, 0).getDate(), endMonth, endYear); // Hari terakhir bulan
    
        // Return URL dengan query string
        return `/api/dashboard/pelaporan/import/pencarian/realisasi-import-b3?startDate=${startDate}&endDate=${endDate}`;
    }, getFetcher);
    
    const { data: realisasiB3Tahun, mutate: mutateRealisasiB3Tahun } = useSWR(() => {
        // Validasi filter
        const startYear = filters.realisasiB3Tahun.year || new Date().getFullYear(); // Default ke tahun ini jika tidak ada
    
        // Format tanggal dengan zero padding
        const formatDate = (day, month, year) => `${day.toString().padStart(2, "0")}-${month.toString().padStart(2, "0")}-${year}`;
        
        // Tanggal awal dan akhir
        const startDate = formatDate(1, 1, startYear); // Hari pertama bulan
        const endDate = formatDate(31, 12, startYear); // Hari terakhir bulan
    
        // Return URL dengan query string
        return `/api/dashboard/pelaporan/import/pencarian/realisasi-import-b3-tahun?startDate=${startDate}&endDate=${endDate}`;
    },
        getFetcher
    );
    
    const { data: realisasiPerusahaan, mutate: mutateRealisasiPerusahaan } = useSWR(
        `/api/dashboard/pelaporan/import/pencarian/realisasi-import-perusahaan?startDate=${startDate}&endDate=${endDate}`,
        getFetcher
    );
    
    const { data: realisasiPerusahaanTahun, mutate: mutateRealisasiPerusahaanTahun } = useSWR(() => {
        // Validasi filter
        const startYear = filters.realisasiPerusahaanTahun.year || new Date().getFullYear(); // Default ke tahun ini jika tidak ada
    
        // Format tanggal dengan zero padding
        const formatDate = (day, month, year) => `${day.toString().padStart(2, "0")}-${month.toString().padStart(2, "0")}-${year}`;
        
        // Tanggal awal dan akhir
        const startDate = formatDate(1, 1, startYear); // Hari pertama bulan
        const endDate = formatDate(31, 12, startYear); // Hari terakhir bulan
    
        // Return URL dengan query string
        return `/api/dashboard/pelaporan/import/pencarian/realisasi-import-perusahaan-tahun?startDate=${startDate}&endDate=${endDate}`;
    },
        getFetcher
    );
    
    const { data: realisasiB3PerusahaanProvinsi, mutate: mutateRealisasiB3PerusahaanProvinsi } = useSWR(() => {
        // Validasi filter
        if (!selectedProvince) return null;
        const startYear = filters.realisasiPerusahaanTahun.year || new Date().getFullYear(); // Default ke tahun ini jika tidak ada
    
        // Format tanggal dengan zero padding
        const formatDate = (day, month, year) => `${day.toString().padStart(2, "0")}-${month.toString().padStart(2, "0")}-${year}`;
        
        // Tanggal awal dan akhir
        const startDate = formatDate(1, 1, startYear); // Hari pertama bulan
        const endDate = formatDate(31, 12, startYear); // Hari terakhir bulan
    
        // Return URL dengan query string
        return `/api/dashboard/pelaporan/import/pencarian/realisasi-import-b3-tahun-provinsi?startDate=${startDate}&endDate=${endDate}&provinceId=${selectedProvince}`;
    },
        getFetcher
    );
    
    const { data: realisasiPerusahaanProvinsiTahun, mutate: mutateRealisasiPerusahaanProvinsiTahun } = useSWR(() => {
            // Validasi filter
            const startYear = filters.realisasiPerusahaanProvinsiTahun.year || new Date().getFullYear(); // Default ke tahun ini jika tidak ada
        
            // Format tanggal dengan zero padding
            const formatDate = (day, month, year) => `${day.toString().padStart(2, "0")}-${month.toString().padStart(2, "0")}-${year}`;
            
            // Tanggal awal dan akhir
            const startDate = formatDate(1, 1, startYear); // Hari pertama bulan
            const endDate = formatDate(31, 12, startYear); // Hari terakhir bulan
        
            // Return URL dengan query string
            return `/api/dashboard/pelaporan/import/pencarian/realisasi-import-perusahaan-tahun-provinsi?startDate=${startDate}&endDate=${endDate}&provinceId=${filters?.realisasiPerusahaanProvinsiTahun?.provinceId ?? 1}`;
        },
        getFetcher
    );
    
    const { data: realisasiB3Provinsi, mutate: mutateRealisasiB3Provinsi } = useSWR(
        `/api/dashboard/pelaporan/import/pencarian/realisasi-import-b3-provinsi?startDate=${startDate}&endDate=${endDate}&provinceId=${selectedProvince}`,
        getFetcher
    );
    
    const { data: realisasiB3TahunProvinsi, mutate: mutateRealisasiB3TahunProvinsi } = useSWR(() => {
        // Validasi filter
        const startYear = filters.realisasiB3TahunProvinsi.year || new Date().getFullYear(); // Default ke tahun ini jika tidak ada
    
        // Format tanggal dengan zero padding
        const formatDate = (day, month, year) => `${day.toString().padStart(2, "0")}-${month.toString().padStart(2, "0")}-${year}`;
        
        // Tanggal awal dan akhir
        const startDate = formatDate(1, 1, startYear); // Hari pertama bulan
        const endDate = formatDate(31, 12, startYear); // Hari terakhir bulan
    
        // Return URL dengan query string
        return  `/api/dashboard/pelaporan/import/pencarian/realisasi-import-b3-tahun-provinsi?startDate=${startDate}&endDate=${endDate}&provinceId=${filters?.realisasiB3TahunProvinsi?.provinceId ?? 1}`;
    },
        getFetcher
    );
    

    const handleFilterApply = (start, end, provinceId) => {
        setStartDate(start);
        setEndDate(end);
        setSelectedProvince(provinceId);
        // mutatePerbandingan();
        // mutateB3();
        // mutatePerusahaan();
        // mutateNegaraAsal();
        // mutatePelabuhanBongkar();
        // mutateRealisasiB3();
        // mutateRealisasiB3Tahun();
        // mutateRealisasiPerusahaan();
        // mutateRealisasiPerusahaanTahun();
        // mutateRealisasiB3PerusahaanProvinsi();
        // mutateRealisasiPerusahaanProvinsiTahun();
        // mutateRealisasiB3Provinsi();
        // mutateRealisasiB3TahunProvinsi();
    };
    
    useEffect(() => {
        mutateRealisasiB3Tahun();
    }, [filters.realisasiB3]);

    useEffect(() => {
        mutateRealisasiB3TahunProvinsi();
    }, [filters.realisasiB3TahunProvinsi]);

    useEffect(() => {
        mutateRealisasiPerusahaanTahun();
    }, [filters.realisasiPerusahaanTahun]);

    useEffect(() => {
        mutateRealisasiPerusahaanProvinsiTahun();
    }, [filters.realisasiPerusahaanProvinsiTahun]);

    useEffect(() => {
        mutateNegaraAsal();
    }, [filters.negaraAsal]);

    useEffect(() => {
        mutatePelabuhanBongkar();
    }, [filters.pelabuhanBongkar]);

    return (<RootAdmin>
            <HeaderPage
                title="Grafik Pelaporan Import"
                subtitle="Gambaran Umum"
                action={
                    <FilterForm
                        onApplyFilter={handleFilterApply}
                        provinces={provinces}
                        selectedProvince={selectedProvince}
                        setSelectedProvince={setSelectedProvince}
                    />
                }
            />
            <div className='grid grid-rows-1 md:grid-rows-4 gap-3 pt-5'>
                <Card>
                    <Tabs aria-label="Pelaporan Grafik B3" defaultValue="perbadinngan">
                        {/* Tab 1: Perbandingan Perencanaan dan Realisasi */}
                        {/* <Tab title="Grafik Perbandingan Perencanaan Dan Realisasi" value="perbandingan">
                            {renderChartAndTable(
                                perbandingan?.responseData,
                                "Perbandingan Perencanaan Dan Realisasi",
                                ["Tanggal", "Perencanaan", "Realisasi"],
                                ["key", "perencanaan", "realisasi"]
                            )}
                        </Tab> */}

                        {/* Tab 2: B3 Terbanyak */}
                        {/* <Tab title="Grafik Besaran B3 Terbanyak Diangkut" value="b3Terbanyak">
                            {renderChartAndTable(
                                b3?.responseData,
                                "10 Jenis B3 Terbanyak Di Import",
                                ["Jenis B3", "Jumlah"],
                                ["namaBahanKimia", "count"]
                            )}
                        </Tab> */}

                        {/* Tab 3: Realisasi Import B3 */}
                        {/* <Tab title="Realisasi Import B3 Per Bulan" value="realisasiB3">
                        <FilterInTab
                            filters={filters.realisasiB3}
                            onApply={(newFilters) => updateFilter("realisasiB3", newFilters)}
                            disableMonth={false}
                        />
                            {renderChartAndTableForRealisasi(
                                realisasiB3?.responseData?.bahanb3,
                                "Realisasi Import B3",
                                ["Tahun", "Bulan", "Nomor CAS", "Nama Bahan Kimia", "Realisasi"],
                                ["periode_tahun", "periode_bulan", "cas_number", "nama_bahan_kimia", "realisasi_impor"],
                                "nama_bahan_kimia",
                                "realisasi_impor"
                            )}
                        </Tab> */}

                        {/* Tab 4: Realisasi Import B3 Per Tahun */}
                        <Tab title="Realisasi Import B3 Per Tahun" value="realisasiB3Tahun">
                            <FilterInTab
                                filters={filters.realisasiB3Tahun}
                                onApply={(newFilters) => updateFilter("realisasiB3Tahun", newFilters)}
                                disableMonth={true}
                            />
                            {renderChartAndTableForRealisasi(
                                realisasiB3Tahun?.responseData?.bahanb3,
                                "Realisasi Import B3 Per Tahun",
                                ["Tahun", "Nomor CAS", "Nama Bahan Kimia", "Realisasi"],
                                ["periode_tahun", "cas_number", "nama_bahan_kimia", "realisasi_impor"],
                                "nama_bahan_kimia",
                                "realisasi_impor"
                            )}
                        </Tab>

                        {/* Tab 5: Realisasi Perusahaan */}
                        {/* <Tab title="Realisasi Import Perusahaan" value="realisasiPerusahaan">
                            <FilterInTab
                                filters={filters.realisasiPerusahaan}
                                onApply={(newFilters) => updateFilter("realisasiPerusahaan", newFilters)}
                                disableMonth={false}
                            />
                            {renderChartAndTableForRealisasi(
                                realisasiPerusahaan?.responseData?.bahanb3,
                                "Realisasi Import Berdasarkan Perusahaan",
                                ["Tahun", "Bulan","Perusahaan", "Realisasi"],
                                ["periode_tahun", "periode_bulan","nama_kustomer", "realisasi_impor"],
                                "nama_kustomer",
                                "realisasi_impor"
                            )}
                        </Tab> */}

                        {/* Tab 6: Realisasi Perusahaan Per Tahun */}
                        <Tab title="Realisasi Import Perusahaan Per Tahun" value="realisasiPerusahaanTahun">
                            <FilterInTab
                                    filters={filters.realisasiPerusahaanTahun}
                                    onApply={(newFilters) => updateFilter("realisasiPerusahaanTahun", newFilters)}
                                    disableMonth={true}
                            />
                            {renderChartAndTableForRealisasi(
                                realisasiPerusahaanTahun?.responseData?.bahanb3,
                                "Realisasi Import Perusahaan Per Tahun",
                                ["Tahun", "Perusahaan", "Realisasi"],
                                ["periode_tahun", "nama_kustomer", "realisasi_impor"],
                                "nama_kustomer",
                                "realisasi_impor"
                            )}
                        </Tab>


                        {/* Tab 8: Realisasi Import B3 Per Tahun Provinsi */}
                        <Tab title="Realisasi Import B3 Per Tahun Provinsi" value="realisasiB3TahunProvinsi">
                        <FilterInTab
                                    filters={filters.realisasiB3TahunProvinsi}
                                    onApply={(newFilters) => updateFilter("realisasiB3TahunProvinsi", newFilters)}
                                    disableMonth={true}
                                    disableProvince={false}
                            />
                            {renderChartAndTableForRealisasi(
                                realisasiB3TahunProvinsi?.responseData?.bahanb3,
                                "Realisasi Import B3 Per Tahun Berdasarkan Provinsi",
                                ["Nomor CAS", "Nama Bahan Kimia", "Tahun", "Provinsi", "Realisasi"],
                                ["cas_number", "nama_bahan_kimia", "periode_tahun", "provinsi", "realisasi_impor"],
                                "nama_bahan_kimia",
                                "realisasi_impor"
                            )}
                        </Tab>

                        {/* Tab 8: Realisasi Import B3 Per Tahun Provinsi */}
                        {/* <Tab title="Realisasi Import Perusahaan Time Range Provinsi" value="realisasiB3TahunProvinsi">
                            {renderChartAndTable(
                                realisasiB3PerusahaanProvinsi?.responseData,
                                "Realisasi Import Perusahaan Time Range Berdasarkan Provinsi",
                                ["Nama Perusahaan", "Bulan", "Tahun", "Provinsi", "Realisasi"],
                                ["nama_kustomer", "periode_bulan", "periode_tahun", "provinsi", "realisasi_impor"]
                            )}
                        </Tab> */}

                        {/* Tab 8: Realisasi Import B3 Per Tahun Provinsi */}
                        <Tab title="Realisasi Import Perusahaan Per Tahun Provinsi" value="realisasiPerusahaanProvinsiTahun">
                        <FilterInTab
                                    filters={filters.realisasiPerusahaanProvinsiTahun}
                                    onApply={(newFilters) => updateFilter("realisasiPerusahaanProvinsiTahun", newFilters)}
                                    disableMonth={true}
                                    disableProvince={false}
                            />
                            {renderChartAndTableForRealisasi(
                                realisasiPerusahaanProvinsiTahun?.responseData?.bahanb3,
                                "Realisasi Import Perusahaan Per Tahun Berdasarkan Provinsi",
                                ["Nama Perusahaan","Tahun", "Provinsi", "Realisasi"],
                                ["nama_kustomer", "periode_tahun", "provinsi", "realisasi_impor"],
                                "nama_kustomer",
                                "realisasi_impor"
                                 
                            )}
                        </Tab>

                        {/* <Tab title="Grafik Produksi B3 Berdasarkan Perusahaan" value="B3TerbanyakPerusahaan">
                            <Card radius='sm' className='col-span-4'>
                                <CardHeader>
                                    <span className='text-primary text-xl font-bold'>10 Jenis B3 Terbanyak Berdasarkan Perusahaan</span>
                                </CardHeader>
                                <CardBody className='w-full flex flex-col items-center py-5 text-center'>
                                    <BarChart
                                        xAxis={[{
                                            scaleType: 'band',
                                            data: (perusahaan?.responseData || []).map(item => item.name),
                                            label: 'Perusahaan',
                                            barGapRatio: 0,
                                            categoryGapRatio: 0.4,
                                        }]}
                                        series={[
                                            { data: (perusahaan?.responseData || []).map(item => item.count) },
                                        ]}
                                        height={300}
                                    />
                                </CardBody>
                            </Card>
                            <div className='col-span-4 mt-5'>
                                <Table aria-label="Example static collection table">
                                    <TableHeader>
                                        <TableColumn>Perusahaan</TableColumn>
                                        <TableColumn>Jumlah Produksi</TableColumn>
                                    </TableHeader>
                                    <TableBody>
                                        {(perusahaan?.responseData || []).map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.name}</TableCell>
                                                <TableCell>{item.count}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </Tab> */}

                        <Tab title="Grafik Asal Negara" value="asalNegara">
                        <FilterInTab
                                    filters={filters.negaraAsal}
                                    onApply={(newFilters) => updateFilter("negaraAsal", newFilters)}
                                    disableMonth={true}
                                    disableProvince={true}
                                />  
                        {renderChartAndTableForRealisasi(
                                negaraAsal?.responseData,
                                "Data Realisasi Import Berdasarkan Asal Negara",
                                ["Nama Negara","Realisasi Import (Kg)"],
                                ["asal_negara", "count"],
                                "asal_negara",
                                "count"
                                 
                            )}
                        </Tab>

                        <Tab title="Grafik Pelabuhan Bongkar" value="pelabuhanBongkar">
                        <FilterInTab
                                    filters={filters.pelabuhanBongkar}
                                    onApply={(newFilters) => updateFilter("pelabuhanBongkar", newFilters)}
                                    disableMonth={true}
                                    disableProvince={true}
                                />  
                        {renderChartAndTableForRealisasi(
                                pelabuhanBongkar?.responseData,
                                "Data Realisasi Import Berdasarkan Pelabuhan Bongkar",
                                ["Nama Pelabuhan","Jumlah Bongkar (Kg)"],
                                ["nama_pelabuhan", "count"],
                                "nama_pelabuhan",
                                "count"
                                 
                            )}
                        </Tab>
                    </Tabs>
                </Card>
            </div>
        </RootAdmin>)
}

function FilterForm({ onApplyFilter, provinces, selectedProvince, setSelectedProvince }) {
    const { control, watch } = useForm({
        defaultValues: {
            startDate: "",
            endDate: "",
        },
    });
    const filters = watch();

    const handleApply = () => {
        
        onApplyFilter(format(filters?.startDate, 'dd-MM-yyyy'), format(filters?.endDate, 'dd-MM-yyyy'), selectedProvince);
    };

    return (
        <Dropdown closeOnSelect={false}>
            <DropdownTrigger>
                <Button radius='sm' variant='bordered' startContent={<FunnelIcon className='size-4' />}>
                    Saring
                </Button>
            </DropdownTrigger>
            <DropdownMenu aria-label="Filter Date">
                <DropdownItem isReadOnly>
                    <ControlledInput
                        name="startDate"
                        label="Tanggal Mulai"
                        type="date"
                        control={control}
                        isRequired
                        rules={{
                            required: "Tanggal Mulai harus diisi.",
                        }}
                    />
                </DropdownItem>
                <DropdownItem isReadOnly>
                    <ControlledInput
                        name="endDate"
                        label="Tanggal Selesai"
                        type="date"
                        control={control}
                        isRequired
                        rules={{
                            required: "Tanggal Selesai harus diisi.",
                        }}
                    />
                </DropdownItem>
                <DropdownItem isReadOnly>
                    <Select
                        label="Provinsi"
                        placeholder="Pilih Provinsi"
                        value={selectedProvince}
                        onChange={(e) => setSelectedProvince(e.target.value)}
                    >
                        {provinces?.responseData?.map(prov => (
                            <SelectItem key={prov.id} value={prov.id}>
                                {prov.name}
                            </SelectItem>
                        ))}
                    </Select>
                </DropdownItem>
                <DropdownItem isReadOnly>
                    <Button size='sm' color='primary' onClick={handleApply}>
                        Terapkan
                    </Button>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
}

// function renderChartAndTable(data, title, columns, dataKeys) {
//     const safeData = Array.isArray(data) ? data : []; // Pastikan data adalah array

//     return (
//         <>
//             <Card radius="sm" className="col-span-4">
//                 <CardHeader>
//                     <span className="text-primary text-xl font-bold">{title}</span>
//                 </CardHeader>
//                 <CardBody className="w-full flex flex-col items-center py-5 text-center">
//                     <BarChart
//                         xAxis={[
//                             {
//                                 scaleType: "band",
//                                 data: safeData?.map((item) => item[dataKeys[0]] || "N/A"),
//                                 label: columns[0],
//                                 barGapRatio: 0,
//                                 categoryGapRatio: 0.4,
//                             },
//                         ]}
//                         series={[
//                             {
//                                 data: safeData?.map((item) => item[dataKeys[1]] || 0),
//                             },
//                         ]}
//                         height={300}
//                     />
//                 </CardBody>
//             </Card>

//             <div className="col-span-4 mt-5">
//                 <Table aria-label="Data Table">
//                     <TableHeader>
//                         {columns?.map((col, idx) => (
//                             <TableColumn key={idx}>{col}</TableColumn>
//                         ))}
//                     </TableHeader>
//                     <TableBody>
//                     {safeData?.map((item, index) => (
//                         <TableRow key={index}>
//                             {dataKeys.map((key, idx) => (
//                                 <TableCell key={idx}>
//                                     {key === "periode_bulan" 
//                                         ? translateMonth(item[key]) || "N/A" 
//                                         : item[key] || "N/A"}
//                                 </TableCell>
//                             ))}
//                         </TableRow>
//                     ))}
//                     </TableBody>
//                 </Table>
//             </div>
//         </>
//     );
// }

function renderChartAndTable(data, title, columns, dataKeys) {
    const safeData = Array.isArray(data) ? data : []; // Pastikan data adalah array
  
    // Urutkan data berdasarkan nilai y-axis (jika perlu)
    const sortedData = safeData.sort((a, b) => (Number(b[dataKeys[1]]) || 0) - (Number(a[dataKeys[1]]) || 0));
  
    // Highcharts options
    const chartOptions = {
      chart: {
        type: "column",
        scrollablePlotArea: {
          minWidth: 800, // Scroll jika data banyak
        },
      },
      title: {
        text: title,
      },
      xAxis: {
        categories: sortedData.map((item) => item[dataKeys[0]] || "N/A"),
        title: {
          text: columns[0],
        },
        labels: {
          rotation: -45, // Rotasi untuk label panjang
          style: {
            fontSize: "10px",
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: columns[1],
        },
      },
      series: [
        {
          name: columns[1],
          data: sortedData.map((item) => Number(item[dataKeys[1]]) || 0),
        },
      ],
      tooltip: {
        formatter: function () {
          return `<b>${this.x}</b>: ${this.y.toLocaleString()}`;
        },
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
          },
        },
      },
      exporting: {
        url: HIGHCHART_URL,
        enabled: true,
        showTable: true,
        },
    };
  
    return (
      <>
        <Card radius="sm" className="col-span-4">
          <CardHeader>
            <span className="text-primary text-xl font-bold">{title}</span>
          </CardHeader>
          <CardBody className="w-full flex flex-col">
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
          </CardBody>
        </Card>
  
        <div className="col-span-4 mt-5">
          <Table aria-label="Data Table">
            <TableHeader>
              {columns.map((col, idx) => (
                <TableColumn key={idx} className={kelasKolomDariData(dataKeys[idx], sortedData)}>
                  {col}
                </TableColumn>
              ))}
            </TableHeader>
            <TableBody>
              {sortedData.map((item, index) => (
                <TableRow key={index}>
                  {dataKeys.map((key, idx) => (
                    <TableCell key={idx} className={kelasKolom(key, item[key])}>
                      {key === "periode_bulan"
                        ? translateMonth(item[key]) || "N/A"
                        : isiSel(key, item[key])}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </>
    );
  }
  
// function renderChartAndTableForRealisasi(data, title, columns, dataKeys, dataGraphSeries, dataGraphxAxis) {
//     const safeData = Array.isArray(data) ? data : []; // Pastikan data adalah array
//     return (
//         <>
//             <Card radius="sm" className="col-span-4">
//                 <CardHeader>
//                     <span className="text-primary text-xl font-bold">{title}</span>
//                 </CardHeader>
//                 <CardBody className="w-full flex flex-col items-center py-5 text-center">
//                     <BarChart
//                         xAxis={[
//                             {
//                                 scaleType: "band",
//                                 data: safeData?.map((item) => item[dataGraphSeries] || "N/A"),
//                                 label: columns[0],
//                                 barGapRatio: 0,
//                                 categoryGapRatio: 0.4,
//                             },
//                         ]}
//                         series={[
//                             {
//                                 data: safeData?.map((item) => item[dataGraphxAxis] || 0),
//                             },
//                         ]}
//                         height={300}
//                     />
//                 </CardBody>
//             </Card>

//             <div className="col-span-4 mt-5">
//                 <Table aria-label="Data Table">
//                     <TableHeader>
//                         {columns?.map((col, idx) => (
//                             <TableColumn key={idx}>{col}</TableColumn>
//                         ))}
//                     </TableHeader>
//                     <TableBody>
//                         {safeData?.map((item, index) => (
//                             <TableRow key={index}>
//                                 {dataKeys.map((key, idx) => (
//                                     <TableCell key={idx}>
//                                         {key === "periode_bulan" 
//                                             ? translateMonth(item[key]) || "N/A" 
//                                             : item[key] || "N/A"}
//                                     </TableCell>
//                                 ))}
//                             </TableRow>
//                         ))}
//                     </TableBody>
//                 </Table>
//             </div>
//         </>
//     );
// }

function renderChartAndTableForRealisasi(data, title, columns, dataKeys, dataGraphSeries, dataGraphxAxis) {
    const safeData = Array.isArray(data) ? data : []; // Pastikan data adalah array
  
    // Urutkan data berdasarkan nilai y-axis
    const sortedData = safeData.sort((a, b) => (Number(b[dataGraphxAxis]) || 0) - (Number(a[dataGraphxAxis]) || 0));
  
    // Highcharts options
    const chartOptions = {
      chart: {
        type: "column",
        scrollablePlotArea: {
          minWidth: 800, // Scroll jika data banyak
        },
      },
      title: {
        text: title,
      },
      xAxis: {
        categories: sortedData.map((item) => item[dataGraphSeries] || "N/A"),
        title: {
          text: columns[0],
        },
        labels: {
          rotation: -45, // Rotasi untuk label panjang
          style: {
            fontSize: "10px",
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "Jumlah Import",
        },
        labels: {
          formatter: function () {
            return this.value >= 1000000
              ? `${(this.value / 1000000).toFixed(1)}M`
              : this.value.toLocaleString();
          },
        },
      },
      series: [
        {
          name: "Jumlah",
          data: sortedData.map((item) => Number(item[dataGraphxAxis]) || 0),
        },
      ],
      tooltip: {
        formatter: function () {
          return `<b>${this.x}</b>: ${this.y.toLocaleString()}`;
        },
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
          },
        },
      },
      exporting: {
        url: HIGHCHART_URL,
        enabled: true,
        showTable: true,
        },
    };
  
    return (
      <>
        <Card radius="sm" className="col-span-4">
          <CardHeader>
            <span className="text-primary text-xl font-bold">{title}</span>
          </CardHeader>
          <CardBody className="w-full flex flex-col">
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
          </CardBody>
        </Card>
  
        <div className="col-span-4 mt-5">
          <Table aria-label="Data Table">
            <TableHeader>
              {columns.map((col, idx) => (
                <TableColumn key={idx} className={kelasKolomDariData(dataKeys[idx], sortedData)}>
                  {col}
                </TableColumn>
              ))}
            </TableHeader>
            <TableBody>
              {sortedData.map((item, index) => (
                <TableRow key={index}>
                  {dataKeys.map((key, idx) => (
                    <TableCell key={idx} className={kelasKolom(key, item[key])}>
                      {key === "periode_bulan"
                        ? translateMonth(item[key]) || "N/A"
                        : isiSel(key, item[key])}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </>
    );
  }
  